<script>
import ApiClient from '../utils/ApiClient'

export default {
  data () {
    return {
      users: []
    }
  },
  /**
   * 総合ランキングを取得する
   * @param transactionId token
   **/
  findAllRankingTune: function (transactionId, callback, errorHandler) {
    var targetPath = 'ajax/ranking.php' + '?transactionid=' + transactionId
    ApiClient.search(targetPath, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getRanking failed')
      console.log(error)
      errorHandler(error)
    })
  },
  /**
   * シーン別ランキングを取得する
   * @param transactionId token
   * @param scenId Number
   **/
  findSceneRankingTune: function (transactionId, scenId, callback, errorHandler) {
    var targetPath = 'ajax/ranking.php' + '?transactionid=' + transactionId + '&scene_id=' + scenId
    ApiClient.search(targetPath, (response) => {
      callback(response.data)
    }, (error) => {
      console.log('getRanking failed')
      console.log(error)
      errorHandler(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/services/RankingService.vue